import { render, staticRenderFns } from "./devoluciones.vue?vue&type=template&id=150e4ca2"
import script from "./devoluciones.vue?vue&type=script&lang=ts"
export * from "./devoluciones.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports